export default (permissionData) => {
  const returnData = JSON.parse(JSON.stringify(permissionData));

  Object.keys(returnData).forEach((serviceId) => {
    Object.keys(returnData[serviceId]).forEach((domainId) => {
      Object.keys(returnData[serviceId][domainId]).forEach((actionId) => {
        const action = returnData[serviceId][domainId][actionId];

        if (!action.selected) {
          delete returnData[serviceId][domainId][actionId];
        }
      });
      if (Object.keys(returnData[serviceId][domainId]).length === 0) {
        delete returnData[serviceId][domainId];
      }
    });
    if (Object.keys(returnData[serviceId]).length === 0) {
      delete returnData[serviceId];
    }
  });
  return returnData;
};



// WEBPACK FOOTER //
// ./src/filters/getDeleteAnEmptyPermission.js